const kokwatchRoutes = [
  {
    path: '/kokwatch',
    component: () => import('@/components/layout/kokwatch/KokwatchLayout.vue'),
    children: [
      ...(process.env.NODE_ENV !== 'production' ? [{
        path: 'prototype/river-flow',
        name: 'kokwatchRiverFlowPrototype',
        component: () => import('@/views/kokwatch/prototype/RiverFlowPrototype.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      }] : []),
      // waterUsage
      {
        path: 'waterusagesurvey/:id?',
        name: 'waterUsageSurvey',
        props: true,
        component: () => import('@/views/kokwatch/survey/waterUsage/WaterUsageSurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'waterusageanslist',
        name: 'waterUsageAnsList',
        component: () => import('@/views/kokwatch/survey/waterUsage/WaterUsageList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'waterusagechart',
        name: 'waterUsageChart',
        component: () => import('@/views/kokwatch/survey/waterUsage/WaterUsageChart.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'waterusagemap',
        name: 'waterUsageMap',
        component: () => import('@/views/kokwatch/survey/waterUsage/WaterUsageMap.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      // end waterUsage

      // envheavy metal
      {
        path: 'envheavymetal/survey/:refId?/:mode?',
        name: 'kokwatchEnvHeavyMetalSurvey',
        props: true,
        component: () => import('@/views/kokwatch/survey/envHeavyMetal/EnvHeavyMetalSurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'envheavymetal/list',
        name: 'kokwatchEnvHeavyMetalList',
        props: true,
        component: () => import('@/views/kokwatch/survey/envHeavyMetal/EnvHeavyMetalList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'envheavymetal/map',
        name: 'kokwatchEnvHeavyMetalMap',
        component: () => import('@/views/kokwatch/survey/envHeavyMetal/EnvHeavyMetalMap.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      
      // researcher
      {
        path: 'envheavymetal/researcher/list',
        name: 'kokwatchEnvHeavyMetalResearchList',
        component: () => import('@/views/kokwatch/survey/envHeavyMetal/researcher/EnvHeavyMetalList.vue'),
        meta: { layout: 'app', sidebar: false, footer: false}
      },
      // end envheavy metal

      // manual
      {
        path: 'manual',
        name: 'kokwatchManual',
        component: () => import('@/views/kokwatch/Manual.vue'),
        meta: { layout: 'app', sidebar: false, footer: false }
      },

      // my survey
      {
        path: 'mysurvey',
        name: 'kokwatchMySurvey',
        component: () => import('@/views/kokwatch/MySurvey.vue'),
        meta: { layout: 'app', sidebar: false, footer: false }
      },
      {
        path: 'chiachart',
        name: 'chiaChart',
        component: () => import('@/views/kokwatch/ChiaChart.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },

      // waterQualityRoutes
      {
        path: 'waterquality/survey/:id?',
        name: 'kokwatchWaterQualitySurvey',
        props: true,
        component: () => import('@/views/kokwatch/survey/waterQuality/WaterQualitySurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      {
        path: 'waterquality/map',
        name: 'kokwatchWaterQualityMap',
        component: () => import('@/views/kokwatch/survey/waterQuality/WaterQualityMap.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      // เลือกคำตอบเพื่อส่งตัวอย่าง
      {
        path: 'waterquality/sample/select',
        name: 'kokwatchWaterQualitySampleSelect',
        component: () => import('@/views/kokwatch/survey/waterQuality/sample/WaterQualitySampleSelect.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      // ตอบแบบฟอร์มส่งตัวอย่าง
      {
        path: 'waterquality/sample/id/:id/:mode?',
        name: 'kokwatchWaterQualitySampleSurvey',
        props: true,
        component: () => import('@/views/kokwatch/survey/waterQuality/sample/WaterQualitySampleSurvey.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      // แสดงรายการแบบฟอร์มส่งตัวอย่าง
      {
        path: 'waterquality/sample/list',
        name: 'kokwatchWaterQualitySampleList',
        component: () => import('@/views/kokwatch/survey/waterQuality/sample/WaterQualitySampleList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      // admin
      {
        path: 'waterquality/list',
        name: 'kokwatchWaterQualityList',
        component: () => import('@/views/kokwatch/survey/waterQuality/WaterQualityList.vue'),
        meta: { layout: 'auth', sidebar: false, footer: false }
      },
      // end admin
      // end waterQualityRoutes
    ]
  }
];

export default kokwatchRoutes;
